module.exports = __webpack_public_path__ + "media/images/f_3-3ab43178df20106569c189c9905f85c4.png";